<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="storage w">
    <Row class="storage-content">
      <Col span="12" class="h-full content-image">.</Col>
      <Col span="12" class="h-full relative content-text">
        <div class="h-auto w-full">
          <div class="detail-text">
            <h6>概述</h6>
            <div class="bars">
              <span class="inline-block bar h-full"></span>
            </div>
            <div class="detail-content">
              干库，即信息库，也指临床资料存储库，收集包含与样本相关的所有临床信息、随访信息、样本动态信息和样本使用反馈信息等内容，并采用国际医学标准术语和国际疾病分类标准编码，对每一个条目进行统一标识、编码、定义，用于支持科学研究及其相关数据分析。
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'storageComponent',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {
      hooperSettings: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        // effect: 'fade',
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.storage {
  padding: 4.48vw 0;
  .storage-content {
    height: 15.89vw; //305px;
  }
  .content-image {
    background-image: url('/static/images/background/information1.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 0.78vw 0 0 0.78vw;
  }
  .content-text {
    border-radius: 0 0.78vw 0.78vw 0; //0 15px 15px 0;
    border: 1px solid #e2e3e5;
    padding: 3.125vw 5.73vw 0 4.375vw; //60px 110px 0 84px;
  }
  .detail-text {
    h6 {
      font-size: 1.46vw; //28px;
      line-height: 2.03vw; //39px;
      color: #111a2e;
      margin-bottom: 0.42vw; //8px;
    }
    .bars {
      height: 4px;
      margin-bottom: 1.04vw; //20px;
    }
    .bar {
      width: 2.7vw; //52px;
      background: #46bfb8;
      float: left;
    }
  }
  .detail-content {
    font-size: 1.04vw; //20px;

    letter-spacing: 1px;
    color: #646a77;
  }
  .operation {
    height: 9.9vw; //190px;
    background-image: url('/static/images/background/operation.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
    margin-bottom: 5.625vw; //108px;
    margin-top: 3.44vw; //66px;
  }
}
</style>
